import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from './locales/en.json';
import fr from './locales/fr.json';
import de from './locales/de.json';
import ru from './locales/ru.json';

const resources = {
  en: {
    translation: en,
  },
  fr: {
    translation: fr,
  },
  de: {
    translation: de,
  },
  ru: {
    translation: ru,
  },
};

const getInitialLanguage = () => {
  const storedLang = localStorage.getItem('i18nextLng');
  if (storedLang && ['en', 'fr', 'de', 'ru'].includes(storedLang)) {
    return storedLang;
  }

  const browserLang = navigator.language.split('-')[0];
  if (['en', 'fr', 'de', 'ru'].includes(browserLang)) {
    return browserLang;
  }

  return 'en';
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
  lng: getInitialLanguage(),
  debug: process.env.NODE_ENV === 'development',

  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
